import Typography from 'typography';

const typography = new Typography();

export const rhythm = typography.rhythm;

export default typography;
